import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import RoleService from '../../services/RoleService';
import TeamMemberService from '../../services/TeamMemberService';
import Select from '../ui/Select';
import Button from '../ui/Button';

const TeamForm = ({ setOpen, loadMembers, editData }) => {

    const isEdit = Boolean(editData?.id);

    const [formData, setFormData] = useState({
        fullname: '',
        roleId: '',
        experience: '',
        gender: '',
        mobile: '',
        email: '',
        password: '',
        address: '',
        activityStatusId: 1,
        memberStatusId: 1,
        emirateId: ""
    });

    useEffect(() => {
        if (editData) {
            setFormData({
                fullname: editData.fullname || '',
                roleId: editData.roleId || '',
                experience: editData.experience || '',
                gender: editData.gender || '',
                mobile: editData.mobile || '',
                email: editData.email || '',
                password: '',
                address: editData.address || '',
                activityStatusId: editData.activityStatusId || 1,
                memberStatusId: editData.memberStatusId || 1,
                emirateId: editData.emirateId || ''
            });
        }
    }, [editData]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            if (isEdit) {
                const body = { ...formData };
                if (!body.password) delete body.password;
                const response = await TeamMemberService.update(editData.id, body);
                toast.success(response.data.message || "Member updated successfully");
            } else {
                const response = await TeamMemberService.create(formData);
                toast.success(response.data.message || "Member created successfully");
            }
            loadMembers();
            setOpen(false);
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong!");
        }
    };

    const [roles, setRoles] = useState([]);
    useEffect(() => {
        RoleService.findAll(1, 10).then(response => {
            if (response?.status === 200) setRoles(response.data);
        }).catch(console.log);
    }, []);

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label className="form-label">Full Name</label>
                    <input
                        className="form-input"
                        name="fullname"
                        value={formData.fullname}
                        onChange={handleChange}
                        required
                    />
                </div>
                <Select
                    label="Role"
                    name="roleId"
                    value={formData.roleId}
                    onChange={handleChange}
                    required
                >
                    <option value="">Select role</option>
                    {roles.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.role_name}
                        </option>
                    ))}
                </Select>
                <div>
                    <label className="form-label">Mobile</label>
                    <input
                        className="form-input"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label className="form-label">Email</label>
                    <input
                        className="form-input"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label className="form-label">{isEdit ? 'New Password (leave blank to keep)' : 'Password'}</label>
                    <input
                        className="form-input"
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required={!isEdit}
                    />
                </div>
                <div>
                    <label className="form-label">Address</label>
                    <input
                        className="form-input"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label className="form-label">Experience in Years</label>
                    <input
                        className="form-input"
                        type="number"
                        name="experience"
                        value={formData.experience}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label className="form-label">Emirates ID</label>
                    <input
                        className="form-input"
                        name="emirateId"
                        value={formData.emirateId}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div>
                <span className="form-label">Gender</span>
                <div className="flex items-center gap-6 mt-1">
                    <label className="flex items-center gap-2 text-sm text-neutral-700">
                        <input
                            type="radio"
                            name="gender"
                            value="male"
                            checked={formData.gender === 'male'}
                            onChange={handleChange}
                            className="accent-seha-500"
                        />
                        Male
                    </label>
                    <label className="flex items-center gap-2 text-sm text-neutral-700">
                        <input
                            type="radio"
                            name="gender"
                            value="female"
                            checked={formData.gender === 'female'}
                            onChange={handleChange}
                            className="accent-seha-500"
                        />
                        Female
                    </label>
                </div>
            </div>

            <div className="flex justify-end pt-2">
                <Button type="submit" variant="primary">
                    {isEdit ? 'Update' : 'Create'}
                </Button>
            </div>
        </form>
    );
};

export default TeamForm;
